// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import {getStatusDate, useIncomingPayment} from '@tectonics/prs/incoming-payment';

export function TicketApprovalDate(): Node {
  return (
    <Root>
      <Term>Aprobado en</Term>
      <Definition data-testid="display-confirmed-date">{ ExpirationDatetime() }</Definition>
    </Root>
  );
}

function ExpirationDatetime(): Node {
  const incomingPayment = useIncomingPayment();
  const statusDate = getStatusDate(incomingPayment);
  if (!statusDate) {
    return null;
  }

  const date = new Date(statusDate);
  const bogotaOffset = -5 * 60;
  const localDate = new Date(date.getTime() + bogotaOffset * 60 * 1000);

  const day = String(localDate.getDate()).padStart(2, '0');
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const hour = String(localDate.getHours()).padStart(2, '0');
  const minutes = String(localDate.getMinutes()).padStart(2, '0');

  return `${day}/${month} ${hour}:${minutes}`;
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;
